/**
 * Event handling utilities
 * Provides helper functions for managing DOM events, particularly for preventing event bubbling
 *
 * @public
 * @useWhen need to stop event bubbling; want to prevent event propagation; need to isolate click handlers
 */

/**
 * Prevents event propagation (bubbling) to parent elements
 * Useful when you have nested clickable elements and want to prevent parent handlers from firing
 *
 * @param event - The DOM event to stop propagation on
 * @public
 * @example
 * ```typescript
 * // In a Vue template
 * <div @click="parentHandler">
 *   <button @click="preventPropagation">Click me</button>
 * </div>
 *
 * // In script
 * import { preventPropagation } from 'src/CrudManager/Core/Utils/clickUtils'
 * ```
 */
export const preventPropagation = (event: Event): void => {
  event.stopPropagation()
}
